export const validateIdVerificationResult = (result, isRequestForMinor) => {
  if (result === 'ERROR') return 'ERROR'
  if (result.isValid === false) return 'NOT_VALID'
  if (result.hasRequest === true && !isRequestForMinor) return 'HAS_REQUEST'
  if (result.age < 18) return 'UNDERAGED'
  return null
}
